// Catálogo oficial de municipios de Hacienda (esquema post-reforma territorial 2021, dependiente de departamento).
// Fuente: catálogo MH provisto por el usuario (docs/cities.csv).
export const municipalityOptions = [
  {
    value: "13",
    label: "AHUACHAPÁN NORTE",
    department: "01"
  },
  {
    value: "14",
    label: "AHUACHAPÁN CENTRO",
    department: "01"
  },
  {
    value: "15",
    label: "AHUACHAPÁN SUR",
    department: "01"
  },
  {
    value: "14",
    label: "SANTA ANA NORTE",
    department: "02"
  },
  {
    value: "15",
    label: "SANTA ANA CENTRO",
    department: "02"
  },
  {
    value: "16",
    label: "SANTA ANA ESTE",
    department: "02"
  },
  {
    value: "17",
    label: "SANTA ANA OESTE",
    department: "02"
  },
  {
    value: "17",
    label: "SONSONATE NORTE",
    department: "03"
  },
  {
    value: "18",
    label: "SONSONATE CENTRO",
    department: "03"
  },
  {
    value: "19",
    label: "SONSONATE ESTE",
    department: "03"
  },
  {
    value: "20",
    label: "SONSONATE OESTE",
    department: "03"
  },
  {
    value: "34",
    label: "CHALATENANGO NORTE",
    department: "04"
  },
  {
    value: "35",
    label: "CHALATENANGO CENTRO",
    department: "04"
  },
  {
    value: "36",
    label: "CHALATENANGO SUR",
    department: "04"
  },
  {
    value: "23",
    label: "LA LIBERTAD NORTE",
    department: "05"
  },
  {
    value: "24",
    label: "LA LIBERTAD CENTRO",
    department: "05"
  },
  {
    value: "25",
    label: "LA LIBERTAD OESTE",
    department: "05"
  },
  {
    value: "26",
    label: "LA LIBERTAD ESTE",
    department: "05"
  },
  {
    value: "27",
    label: "LA LIBERTAD COSTA",
    department: "05"
  },
  {
    value: "28",
    label: "LA LIBERTAD SUR",
    department: "05"
  },
  {
    value: "20",
    label: "SAN SALVADOR NORTE",
    department: "06"
  },
  {
    value: "21",
    label: "SAN SALVADOR OESTE",
    department: "06"
  },
  {
    value: "22",
    label: "SAN SALVADOR ESTE",
    department: "06"
  },
  {
    value: "23",
    label: "SAN SALVADOR CENTRO",
    department: "06"
  },
  {
    value: "24",
    label: "SAN SALVADOR SUR",
    department: "06"
  },
  {
    value: "17",
    label: "CUSCATLAN NORTE",
    department: "07"
  },
  {
    value: "18",
    label: "CUSCATLAN SUR",
    department: "07"
  },
  {
    value: "23",
    label: "LA PAZ OESTE",
    department: "08"
  },
  {
    value: "24",
    label: "LA PAZ CENTRO",
    department: "08"
  },
  {
    value: "25",
    label: "LA PAZ ESTE",
    department: "08"
  },
  {
    value: "10",
    label: "CABAÑAS OESTE",
    department: "09"
  },
  {
    value: "11",
    label: "CABAÑAS ESTE",
    department: "09"
  },
  {
    value: "14",
    label: "SAN VICENTE NORTE",
    department: "10"
  },
  {
    value: "15",
    label: "SAN VICENTE SUR",
    department: "10"
  },
  {
    value: "24",
    label: "USULUTAN NORTE",
    department: "11"
  },
  {
    value: "25",
    label: "USULUTAN ESTE",
    department: "11"
  },
  {
    value: "26",
    label: "USULUTAN OESTE",
    department: "11"
  },
  {
    value: "21",
    label: "SAN MIGUEL NORTE",
    department: "12"
  },
  {
    value: "22",
    label: "SAN MIGUEL CENTRO",
    department: "12"
  },
  {
    value: "23",
    label: "SAN MIGUEL OESTE",
    department: "12"
  },
  {
    value: "27",
    label: "MORAZAN NORTE",
    department: "13"
  },
  {
    value: "28",
    label: "MORAZAN SUR",
    department: "13"
  },
  {
    value: "19",
    label: "LA UNION NORTE",
    department: "14"
  },
  {
    value: "20",
    label: "LA UNION SUR",
    department: "14"
  },
  {
    value: "00",
    label: "Otro (Para extranjeros)",
    department: "00"
  }
]
